import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';

export function NotFoundPage() {
  return (
    <>
      <Seo
        title="Pagina niet gevonden"
        description="Deze ComfortTool™-pagina bestaat niet (meer). Ga naar home of start de scan."
        keywords="ComfortTool 404"
        noindex
      />
      <div className="mx-auto max-w-lg px-4 py-16 text-center text-ct-text">
        <h1 className="text-2xl font-bold">Pagina niet gevonden</h1>
        <p className="mt-4 text-ct-muted" role="status" aria-live="polite">
          Deze URL bestaat niet (meer). Kies hieronder een veilige vervolgstap.
        </p>
        <nav className="mt-8 flex flex-col gap-3 text-sm">
          <Link to="/" className="rounded-xl bg-ct-accent px-5 py-3 font-bold text-white hover:bg-blue-500">
            Naar home
          </Link>
          <Link
            to="/scan"
            className="rounded-xl border border-ct-border px-5 py-3 font-semibold text-ct-text hover:bg-ct-elevated"
          >
            Start de scan
          </Link>
          <Link to="/help" className="text-ct-accent hover:underline">
            Help
          </Link>
          <Link to="/privacy" className="text-ct-accent hover:underline">
            Privacy
          </Link>
        </nav>
      </div>
    </>
  );
}
